import { useUnit } from 'effector-react';
import { Alert, AlertTitle, IconButton, SnackbarCloseReason } from '@mui/material';
import { Close, ContentCopy } from '@mui/icons-material';
import type { Notification as NotificationType } from '@entities/notification/types';
import { ThemeAdapter } from '@shared/theme/adapter';
import { $notification, hideNotification, NotificationGate } from '../../model';
import * as Styled from './styled';

export const Notification = () => {
  const notification = useUnit($notification);

  const handleClose =
    (item: NotificationType) => (_: unknown, reason: SnackbarCloseReason) => {
      if (reason === 'clickaway') {
        return;
      }
      hideNotification(item);
    };

  const handleCloseClick = (item: NotificationType) => () => {
    hideNotification(item);
  };

  const handleCopy = (code: string) => () => {
    navigator.clipboard.writeText(code);
  };

  return (
    <>
      <NotificationGate />

      <ThemeAdapter>
        <Styled.Stack>
          {notification && (
            <Styled.Snackbar
              key={notification.id}
              open
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              autoHideDuration={!notification.action && !notification.code ? 3000 : null}
              onClose={handleClose(notification)}
            >
              <Alert
                severity={notification.severity}
                variant={notification.variant}
                action={
                  (notification.action || notification.code) && (
                    <>
                      {notification.action}
                      <IconButton
                        color="inherit"
                        size="small"
                        onClick={handleCloseClick(notification)}
                        aria-label="close"
                      >
                        <Close fontSize="small" />
                      </IconButton>
                    </>
                  )
                }
              >
                {notification.title && <AlertTitle>{notification.title}</AlertTitle>}
                {notification.label}
                {notification.code && (
                  <Styled.CodeWrapper>
                    {notification.code}
                    <IconButton
                      onClick={handleCopy(notification.code)}
                      size="small"
                      color="inherit"
                    >
                      <ContentCopy fontSize="small" />
                    </IconButton>
                  </Styled.CodeWrapper>
                )}
              </Alert>
            </Styled.Snackbar>
          )}
        </Styled.Stack>
      </ThemeAdapter>
    </>
  );
};
